<template>
  <div>
    <h1>Receivable</h1>
    <div v-if="$apollo.queries.container.loading" uk-spinner>Loading...</div>
    <div class="uk-container" v-else>
      <table class="uk-table uk-table-small uk-margin-remove">
        <thead>
          <th>Rate Name</th>
          <th>Rate Type</th>
          <th>Amount</th>
        </thead>
        <tbody>
          <tr v-for="(charge, chargeIdx) in charges" :key="chargeIdx">
            <td class="uk-padding-remove">{{ charge.name }}</td>
            <td class="uk-padding-remove">
              <div v-if="charge.type === 'base'">Base</div>
              <div v-else>Flat</div>
            </td>
            <td class="uk-padding-remove">
              $<input
                type="text"
                class="uk-input uk-width-small uk-form-small"
                v-model="charge.amount"
              />
            </td>
          </tr>
          <tr>
            <td colspan="2" class="">Total for Container</td>
            <td class="uk-text-right">{{ container.containerTotal }}</td>
          </tr>
        </tbody>
      </table>
      <div class="uk-flex uk-flex-right">
        <Button @click="updateLoadCharges" class="uk-flex">
          Update Charges</Button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import BillingContainerQuery from '@/gql/billing/query/BillingContainer.gql';
import AddLoadCharges from '@/gql/billing/mutations/AddLoadCharges.gql';
import Button from '@/components/core/Button.vue';

export default defineComponent({
  props: {
    containerId: {
      required: true,
      type: String,
    },
  },
  components: {
    Button,
  },
  methods: {
    updateLoadCharges() {
      const vm = (this as any);

      const finalCharges = vm.charges
        .filter((x) => x.amount)
        .map((x) => {
          return { name: x.name, amount: Number(x.amount), type: x.type };
        });

      vm.$apollo.mutate({
        mutation: AddLoadCharges,
        variables: {
          id: vm.containerId,
          charges: finalCharges,
        },
      });
    },
  },
  data() {
    return {
      charges: [
        {
          name: 'Base',
          amount: undefined,
          type: 'base',
        },
        {
          name: 'Fuel Surcharge',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Pier Termination',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Extra Stops',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Lumper Charges',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Detention Charges',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Chassis Split',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Chassis Rent',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Pallets',
          amount: undefined,
          type: 'flat',
        },
        {
          name: 'Other Charges',
          amount: undefined,
          type: 'flat',
        },
      ],
    };
  },
  ...{
    apollo: {
      container: {
        query: BillingContainerQuery,
        variables() {
          return {
            id: (this as any).containerId,
          };
        },
        result(result) {
          const vm = (this as any);

          const rates = result.data.container.rates;
          console.log('rates are');
          console.log(rates);
          const mappedCharges = rates.map((x) => {
            return {
              amount: x.amount,
              name: x.rateDescription,
              type: x.rateType,
            };
          });
          const merged = [];

          // loops through the objects in padding. If it finds an object in data that has the same t value, it chooses the object from data to add to the merged array. Otherwise, it uses the object from padding

          vm.charges.forEach((obj) => {
            let dataObj;
            if (obj.type === 'base') {
              dataObj = mappedCharges.find((ob) => ob.type === obj.type);
            } else {
              dataObj = mappedCharges.find(
                (ob) => ob.name === obj.name && ob.type === obj.type,
              );
            }

            if (dataObj) {
              merged.push(dataObj);
            } else {
              merged.push(obj);
            }
          });
          vm.charges = merged;
        },
      },
    },
  },
});
</script>